export enum ActionType {
    PAGE_DOWNLOAD = 'page_download',
    TITLE_SEARCH = "title_search",
}